import React from "react";
import Headline from "./Headline";
import Paragraph from "./Paragraph";
import {Colors} from "../Types";

const ImageDivider: React.FC<Props> = (
  {
    background,
    header,
    texts,
    headerTextColor
  }
) => {
  return(
    <div className={`flex items-center justify-center flex-col ${background} bg-image`}>
      <div className="flex items-center justify-center flex-col 2xl:h-[30vh] h-[75vh] v-[100vw] px-8">
        <div className="pb-6 max-w-[640px]"><Headline size="h2" color={headerTextColor} textAlign="text-center">{header}</Headline></div>
        <div className="flex flex-col gap-3 max-w-[300px] 2xl:max-w-[560px]">{texts.map((text, index)=>{return <Paragraph key={index} color="text-white" textAlign="text-center" size="text-[15px] 2xl:text-base leading-[1.65]">{text}</Paragraph>})}</div>
      </div>

    </div>
  )
};

export default ImageDivider;

interface Props {
  background: "bg-sfondo-locale"|"bg-sfondo-locale-woman",
  header:string,
  texts:string[],
  headerTextColor:Colors

}